import { render, staticRenderFns } from "./snakeBiteDis.vue?vue&type=template&id=33a4e34a"
import script from "./snakeBiteDis.vue?vue&type=script&lang=js"
export * from "./snakeBiteDis.vue?vue&type=script&lang=js"
import style0 from "./snakeBiteDis.vue?vue&type=style&index=0&id=33a4e34a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports